/**
 * RouteErrorFallback - React Router errorElement 专用
 *
 * 替代 React Router 默认的 "Hey developer..." 错误页面，
 * 给用户一个正常的错误提示和刷新按钮。
 */
import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { AlertCircle, RefreshCw } from 'lucide-react';

export function RouteErrorFallback() {
  const error = useRouteError();

  const isChunkError =
    error instanceof Error &&
    /importing a module script failed|failed to fetch dynamically imported module|loading chunk/i.test(
      error.message
    );

  const title = isRouteErrorResponse(error)
    ? `${error.status} - ${error.statusText}`
    : isChunkError
      ? '页面加载失败'
      : '出错了';

  const description = isChunkError
    ? '应用已更新，请刷新页面获取最新版本'
    : isRouteErrorResponse(error)
      ? error.data?.message || '请求的页面出现问题'
      : error instanceof Error
        ? error.message
        : '发生未知错误，请刷新页面重试';

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="flex h-screen w-full items-center justify-center bg-background">
      <div className="flex max-w-md flex-col items-center text-center">
        <AlertCircle className="mb-4 h-12 w-12 text-destructive" />
        <h1 className="text-lg font-semibold text-foreground">{title}</h1>
        <p className="mt-2 text-sm text-text-secondary">{description}</p>
        <button
          onClick={handleRefresh}
          className="mt-6 inline-flex items-center gap-2 rounded-xl bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          <RefreshCw className="h-4 w-4" />
          刷新页面
        </button>
      </div>
    </div>
  );
}
